module.exports = __webpack_public_path__ + "img/c_photo_5@2x.5cc14992.png";